import { useContext } from 'react';
import { CustomerOrderContext } from 'src/contexts/CustomerOrderContext';

const useCustomerOrderData = () => useContext(CustomerOrderContext);

export default useCustomerOrderData;
